import { render, staticRenderFns } from "./openProduct.vue?vue&type=template&id=c0f17380&scoped=true&"
import script from "./openProduct.vue?vue&type=script&lang=js&"
export * from "./openProduct.vue?vue&type=script&lang=js&"
import style0 from "./openProduct.vue?vue&type=style&index=0&id=c0f17380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f17380",
  null
  
)

export default component.exports